module.exports = __webpack_public_path__ + "fa2367e9f1d2b9f0c679b06d90ef56a8.svg";